import type { TAsrExecutionRetryPolicy } from 'app/API/custom/asr-execution/types';

export const formatRetryPolicy = (policy: TAsrExecutionRetryPolicy | undefined): string => {
  if (!policy) {
    return 'Retry policy not recorded';
  }
  if (policy.count === 0) {
    return 'Retries disabled';
  }
  return `${policy.count} ${policy.count === 1 ? 'retry' : 'retries'} · ${policy.delayMs} ms delay`;
};
